<template>
  <div>
    <!-- 1 is incompleted, 2 is completed, 3 is skipped -->
    <!-- should be set to 1 but is set to 3 to not show up at this stage -->
    <div v-if="this.getVendor.completed_setup == 1">
      <b-container fluid>
        <main class="setupHeader">
          <slot name="main"></slot>
        </main>
      </b-container>
      <header class="header-container">
        <slot name="header"></slot>
      </header>
      <aside class="aside-container">
        <slot name="side-navbar"></slot>
      </aside>
      <mobile-nav-bar />
    </div>

    <div v-else>
      <b-container fluid>
        <main>
          <slot name="main"></slot>
        </main>
      </b-container>
      <aside class="aside-container">
        <slot name="side-navbar"></slot>
      </aside>
      <mobile-nav-bar />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MobileNavBar from "./MobileNavBar.vue";

export default {
  components: {
    MobileNavBar,
  },
  computed: {
    ...mapGetters(["getVendor"]),
  },
};
</script>

<style>
.header-container {
  width: 100%;
  height: 40px;
  position: fixed;
  top: 0px;
  left: 54px;
}

.aside-container {
  width: 54px;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
}

main {
  position: fixed;
  left: 54px;
  top: 0px;
  height: 96%; /* Subtract margins (16px top + 16px bottom) */
  width: calc(
    100% - 54px - 20px
  ); /* Subtract margins (16px left + 16px right) */
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  background: rgba(247, 247, 247, 0.95);
}

.setupHeader {
  height: calc(100% - 40px);
  top: 40px;
}

.container-fluid {
  position: fixed;
  top: 0px;
  left: 0px;
  padding: 0;
  height: 100%;
  width: 100%;
}

@media screen and (max-width: 767px) {
  .aside-container {
    display: none;
  }

  .header-container {
    display: none;
  }

  main {
    left: 0;
    top: 56px; /* Height of mobile navbar */
    width: calc(100% - 20px);
    height: calc(100% - 76px); /* Subtract mobile navbar height and margins */
  }
}
</style>
